var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupportSolid = function SvgSupportSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v-6ZM7 10H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v-6ZM9 20a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 0 3h-3A1.5 1.5 0 0 1 9 20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10v-.875C18 5.742 15.314 3 12 3S6 5.742 6 9.125V10m12 6v2a2 2 0 0 1-2 2h-1m0 0a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1 0-3h3A1.5 1.5 0 0 1 15 20Zm2-10h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2v-6ZM7 10H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v-6Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSupportSolid;